import React, { useEffect, useState, useRef } from "react";
import { useLocation, Link } from "react-router-dom";
import Twemoji from "react-twemoji";

import Loading from "./Loading";
import ImageComponent from "../components/ImageComponent";
import BulletListComponent from "../components/BulletListComponent";
import SourceCodeComponent from "../components/SourceCodeComponent";
import PageHeader from "../components/PageHeader";
import HeadingToc from "../components/HeadingToc";
import ProjectListItem from "../components/ProjectListItem";
import CourtLineDivider from "../components/CourtLineDivider";

export default function About(){
    const location = useLocation();
    const contentRef = useRef(null);

    const isHeading = (type) => type.includes("heading") || type.includes("divider");

    const [loading, setLoading] = useState(true);
    const [data,setData] = useState([]);
    const [lastEdited, setLastEdited] = useState("");

    const [toyProjects, setToyProjects] = useState([]);

    const fetchData = async () => {
        try {
            const response = await fetch(`https://imajin.dev/api/retrieve-block-children-about`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const responseData = await response.json();
            setData(responseData.results);

            const isoDate = responseData.results[0].last_edited_time; //ISO 8601 Timestamp
            const formattedDate = new Date(isoDate).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
            });

            setLastEdited(formattedDate);

            setLoading(false);
        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    };

    const fetchToyProjects = async ( tag ) => {        
    try {
      const response = await fetch("https://imajin.dev/api/query-a-database-projects-toy", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          tag : tag,
        }),
      });
  
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
  
      const result = await response.json();
      console.log("Fetched toy projects:", result);
      setToyProjects(result);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

    useEffect( () => {
        fetchData();
        fetchToyProjects();
    }, []);

    
    let COMPONENTS = {};
    try {
      // webpack's require.context (works in CRA/Webpack environments)
      const req = require.context('../components', false, /\.jsx?$/);
      req.keys().forEach((key) => {
        // key looks like './HW1.jsx' or './Specular.jsx'
        const module = req(key);
        // prefer default export, otherwise take named export
        const comp = module && (module.default || module);
        if (!comp) return;
        // derive name from filename
        const name = key.replace(/^\.\/?/, '').replace(/\.jsx?$/, '');
        COMPONENTS[name] = comp;
      });
    } catch (e) {
      // Fallback: explicit mapping for environments without require.context
      console.error("Failed to auto import from /graphics");
    }

    return (
        <>
        { loading ? <Loading/> :
            <Twemoji options = { { className: 'twemoji' } } key = { location.pathname }>
                <div className = "page">
                    {/* <Console text = { consoleMsg }/> */}

                    <PageHeader title = "ABOUT" date = { lastEdited }/>

                    <HeadingToc containerRef = { contentRef } maxLevel={3}/>

                    <div ref = { contentRef }>
                    { data.map( ( item, index ) => (
                        <div key = { item.id }>
                            <div style = { { display : "flex", flexDirection : "row", gap : "", alignItems : "center",
                                paddingLeft : isHeading(item.type) ? "0px" : "16px" // indent
                                } }>
                            
                                {/* <p className = "meta3" style = { { width : "40px", color : "var(--black16)", fontFamily : "var(--font-Roboto)" } }>{ index % 8 === 0 ? index : "-" }</p> */}

                                { item.type === "paragraph" && (
                                    <div>
                                        { item[item.type]?.rich_text?.length === 0 ? ( 
                                            <div className = "br"/>
                                        ) : item[item.type]?.rich_text?.[0]?.href ? (
                                        <a className = "animated-underline" target="_blank" href={item[item.type]?.rich_text?.[0]?.href}>
                                            { item[item.type]?.rich_text?.[0]?.href }
                                        </a>
                                        ) : (
                                        <p
                                            style = {{
                                            color:
                                                item[item.type]?.color === "black"
                                                ? "black"
                                                : item[item.type]?.color === "blue"
                                                ? "blue"
                                                : "inherit", // Default color
                                            }}
                                        >
                                            { item[item.type]?.rich_text?.[0]?.plain_text }
                                        </p>
                                        )}
                                    </div>
                                )}

                                { item.type === "callout" && (
                                    <div>                
                                        {
                                        COMPONENTS[item[item.type]?.rich_text[0]?.plain_text] &&
                                            React.createElement(
                                            COMPONENTS[item[item.type].rich_text[0].plain_text]
                                            )
                                        }
                                    </div>
                                    )}

                                { item.type === "heading_1" && (
                                    <h1 className = "heading">{item[item.type]?.rich_text[0]?.plain_text}</h1> 
                                )}

                                { item.type === "heading_2" && (
                                    <h2 className = "heading">{item[item.type]?.rich_text[0]?.plain_text}</h2> 
                                )}

                                { item.type === "heading_3" && (
                                    // <RandomText txt={item[item.type]?.rich_text[0]?.plain_text} className = "h3"/>
                                    <h3 className = "heading">{ item[item.type]?.rich_text[0]?.plain_text }</h3> 
                                )}

                                {item.type === "bulleted_list_item" && (
                                    <BulletListComponent item={item} />
                                )}

                                {item.type === "image" && (
                                    <ImageComponent data={item[item.type]} />
                                )}

                                { item.type === "video" && (
                                    <div>
                                        <video style = { { width: '75%', height: 'auto' } } autoPlay muted loop playsInline>
                                            <source src =  { item[item.type].file?.url } type = "video/mp4"/>
                                        </video>
                                        <p className = "caption">{ item[item.type].caption[0]?.plain_text }</p>
                                    </div>
                                )}

                                {/* { item.type === "divider" && <div className = "hr"/>} */}
                                { item.type === "divider" && <CourtLineDivider />}

                                { item.type === "code" && (
                                    <SourceCodeComponent data = {item[item.type]}/>
                                )}

                            </div>
                        </div>
                    ))}
                    </div>

                    <div style = { { display : "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "1rem" } }>
                    { toyProjects.map( ( item, index ) => (
                        <div style = { { paddingBottom : "40px", } } >
                            <Link to = {`/works/${item.id}`} style = { { textDecoration : "none" } }>
                                <div className = "projectThumbnail" style = { { backgroundImage : `url(${item.icon?.file?.url})`, backgroundSize : "cover", backgroundPosition : "center", display : "block" }}/>

                                <div className = "projectsCaption"
                                    style = { { display : "flex", gap : "4px" } }>
                                    <p className = "heading" style = { { lineHeight : "110%", color : "var(--black80)" } }>{ item.properties.Name?.title[0]?.plain_text }</p>
                                    <div className = "projectsCaptionLine" style = { { flex : 1, height : "0.5px" } }/>
                                    
                                </div>
                            </Link>
                        </div>
                    ))}
                    </div>
                </div>
                </Twemoji>
            }
        </>
    );
}

